import React, { useEffect, useState } from 'react';
import env from 'react-dotenv';
import { AdvertEntity } from 'types';


interface Props {
    id: string;
}

export const SingleAdvert = (props: Props) => {
    const [oneAd, setOneAd] = useState<AdvertEntity | null>(null);

    useEffect(() => {
        // console.log(props.id)
        (async () => {
            const res = await fetch(`https://mapsapi.nextwww.pl/card/${props.id}`)
            const advert = await res.json();
            setOneAd(advert.advert);
        })();

    },[]);

    if (oneAd === null) {
        return <p>wczytywanie...</p>
    }
    return (
        <>
        <h3>
            Nazwa: {oneAd.name}
        </h3>
        <p>{oneAd.description}</p>
        <a href={oneAd.url} target="_blank" rel="noreferrer">{oneAd.url}</a>
        <br />
        {!!oneAd.price && <p>{oneAd.price} zł</p>}
        </>
    );
}